import {z} from 'zod';
import {pebbleplotContainerSchema} from './pebbleplotContainerSchema';
import {pebbleplotNumberLineSchema} from './pebbleplotNumberLineSchema';
import {pebbleplotScatterSchema} from './pebbleplotScatterSchema';
import {pebbleplotTitleSchema} from './pebbleplotTitleSchema';

// Main PebblePlot schema - discriminated union for future graph types
// Container and title are optional and apply to all graph types
export const pebbleplotJsonSchema = z
  .object({
    container: pebbleplotContainerSchema,
    title: pebbleplotTitleSchema,
  })
  .and(z.discriminatedUnion('type', [pebbleplotNumberLineSchema, pebbleplotScatterSchema]));

export type PebblePlotJson = z.infer<typeof pebbleplotJsonSchema>;
